<div class="container-fluid p-0">
  <!-- Card Container -->
  <div class="custom-config-card">
    <!-- Card Header with title and save buttons -->
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Custom Resources</h5>
      <!-- <div class="action-buttons">
        <button class="btn btn-outline-primary me-2" (click)="saveConfig(false)">
          <i class="fa fa-save me-1"></i> Save
        </button>
        <button class="btn btn-primary" (click)="saveConfig(true)">
          <i class="fa fa-upload me-1"></i> Save and Publish
        </button>
      </div> -->
    </div>
    
    <!-- Card Body with form -->
    <div class="card-body">
      <form>
        <!-- Custom CSS -->
        <div class="form-row mb-4">
          <div class="form-group col-12">
            <label class="control-label mb-2" for="custom-css">Custom CSS</label>
            
            <div class="file-upload-container d-flex mb-2">
              <div class="file-name-display me-3 flex-grow-1">
                <span *ngIf="customConfig.css[0].name">{{customConfig.css[0].name}}</span>
                <span *ngIf="!customConfig.css[0].name" class="text-muted">No file selected</span>
                <button *ngIf="customConfig.css[0].name" 
                       class="btn-close ms-2" 
                       (click)="removeItem('local', 'css')" 
                       title="Remove file">
                </button>
              </div>
              
              <div class="upload-button">
                <button class="btn btn-primary" 
                       [disabled]="customConfig.css[0].name"
                       (click)="cssFileInput.click()">
                  Choose File
                </button>
                <input #cssFileInput type="file" 
                       class="d-none" 
                       (change)="onFileSelect($event, 'css')" 
                       accept=".css">
              </div>
            </div>
            
            <!-- Display uploaded files URLs -->
            <div class="uploaded-files-list">
              <div *ngFor="let cssFile of customConfigUrl.css; let i = index" class="uploaded-file-item">
                <a [href]="cssFile" target="_blank" class="file-url">
                  {{cssFile}}
                </a>
                <button class="btn-close ms-2" 
                       (click)="removeItem('remote', 'css')" 
                       title="Remove file">
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Custom JavaScript -->
        <div class="form-row mb-4">
          <div class="form-group col-12">
            <label class="control-label mb-2" for="custom-javascript">Custom JavaScript</label>
            
            <div class="file-upload-container d-flex mb-2">
              <div class="file-name-display me-3 flex-grow-1">
                <span *ngIf="customConfig.javascript[0].name">{{customConfig.javascript[0].name}}</span>
                <span *ngIf="!customConfig.javascript[0].name" class="text-muted">No file selected</span>
                <button *ngIf="customConfig.javascript[0].name" 
                       class="btn-close ms-2" 
                       (click)="removeItem('local', 'javascript')" 
                       title="Remove file">
                </button>
              </div>
              
              <div class="upload-button">
                <button class="btn btn-primary" 
                       [disabled]="customConfig.javascript[0].name"
                       (click)="jsFileInput.click()">
                  Choose File
                </button>
                <input #jsFileInput type="file" 
                       class="d-none" 
                       (change)="onFileSelect($event, 'javascript')" 
                       accept=".js">
              </div>
            </div>
            
            <!-- Display uploaded files URLs -->
            <div class="uploaded-files-list">
              <div *ngFor="let jsFile of customConfigUrl.javascript; let i = index" class="uploaded-file-item">
                <a [href]="jsFile" target="_blank" class="file-url">
                  {{jsFile}}
                </a>
                <button class="btn-close ms-2" 
                       (click)="removeItem('remote', 'javascript')" 
                       title="Remove file">
                </button>
              </div>
            </div>
            
            <!-- Documentation link -->
            <div class="documentation-link mt-2">
              <a href="https://static1.litmusworld.com/doc/Instructions_about_Custom_Js.pdf" 
                 target="_blank" 
                 class="text-decoration-underline fst-italic">
                Custom JS Documentation
              </a>
            </div>
          </div>
        </div>
        
        <!-- Google Analytics Code -->
        <div class="form-row">
          <div class="form-group col-12">
            <label class="control-label mb-2" for="google-analytics-code">Google Analytics Code</label>
            <input type="text" 
                   class="form-control" 
                   id="google-analytics-code" 
                   (change)="updateGoogleAnalyticsCode($event)"
                   placeholder="Enter your Google Analytics tracking ID" 
                   [(ngModel)]="customConfig.googleAnalyticsCode"
                   name="googleAnalyticsCode">
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<style>
  /* Modern styling */
  :host {
    display: block;
    padding: 20px;
  }
  
  /* Custom Config Card */
  .custom-config-card {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin-bottom: 20px;
    overflow: hidden;
    border: 1px solid #f0f0f0;
  }
  
  /* Card Header */
  .card-header {
    padding: 16px 20px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #f0f0f0;
  }
  
  /* Card Body */
  .card-body {
    padding: 20px;
  }
  
  /* Form Controls */
  .form-control {
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
    border: 1px solid #e0e0e0;
    padding: 0.6rem 0.75rem;
    transition: all 0.2s ease;
  }
  
  .form-control:focus {
    border-color: #0d6efd;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  }
  
  /* File Upload */
  .file-upload-container {
    border: 1px dashed #e0e0e0;
    padding: 10px 15px;
    border-radius: 6px;
    background-color: #f8f9fa;
  }
  
  .file-name-display {
    display: flex;
    align-items: center;
  }
  
  /* Uploaded Files List */
  .uploaded-files-list {
    margin-top: 8px;
  }
  
  .uploaded-file-item {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    margin-bottom: 4px;
  }
  
  .file-url {
    color: #0d6efd;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .file-url:hover {
    text-decoration: underline;
  }
  
  /* Documentation link */
  .documentation-link {
    font-size: 0.875rem;
  }
  
  .documentation-link a {
    color: #0d6efd;
  }
  
  /* Labels */
  .control-label {
    font-weight: 500;
    color: #212529;
  }
  
  /* Save buttons */
  .action-buttons button {
    display: inline-flex;
    align-items: center;
    font-weight: 500;
    height: 38px;
  }
</style>
